// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const doubleLampPost = defineModel({
  id: "double-lamp-post",
  batchId: "future",
  name: "Double lamp post",
  tags: ["scenery","double","lamp","post","low-poly","age-of-mcp","future"],
  summary: "A twin-headed lamp post — brighter light for grand avenues.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.3,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.2, 0.06, 0.2), color: "#474d53", position: [0, 0.03, 0] },
      { geometry: new THREE.CylinderGeometry(0.07, 0.09, 0.1, 8), color: "#33383d", position: [0, 0.11, 0] },
      { geometry: new THREE.CylinderGeometry(0.028, 0.04, 1.15, 8), color: "#33383d", position: [0, 0.73, 0] },
      { geometry: new THREE.TorusGeometry(0.045, 0.012, 4, 8), color: "#474d53", position: [0, 1.1, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.ConeGeometry(0.04, 0.12, 6), color: "#33383d", position: [0, 1.42, 0] },
      { geometry: new THREE.SphereGeometry(0.025, 5, 4), color: "#474d53", position: [0, 1.5, 0] },
      { geometry: new THREE.BoxGeometry(0.24, 0.025, 0.025), color: "#33383d", position: [0.12, 1.26, 0] },
      { geometry: new THREE.TorusGeometry(0.05, 0.012, 4, 8, 3.141593), color: "#33383d", position: [0.24, 1.2, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.108, 0.144, 0.108), color: "#ffe6b0", position: [0.26, 1.08, 0] },
      { geometry: new THREE.SphereGeometry(0.045, 7, 6), color: "#fff0c2", position: [0.26, 1.08, 0] },
      { geometry: new THREE.BoxGeometry(0.117, 0.018, 0.117), color: "#33383d", position: [0.26, 1.152, 0] },
      { geometry: new THREE.ConeGeometry(0.09, 0.09, 4), color: "#262a2e", position: [0.26, 1.206, 0], rotation: [0, 0.785398, 0] },
      { geometry: new THREE.BoxGeometry(0.24, 0.025, 0.025), color: "#33383d", position: [-0.12, 1.26, 0] },
      { geometry: new THREE.TorusGeometry(0.05, 0.012, 4, 8, 3.141593), color: "#33383d", position: [-0.24, 1.2, 0], rotation: [1.570796, 0, 3.141593] },
      { geometry: new THREE.BoxGeometry(0.108, 0.144, 0.108), color: "#ffe6b0", position: [-0.26, 1.08, 0] },
      { geometry: new THREE.SphereGeometry(0.045, 7, 6), color: "#fff0c2", position: [-0.26, 1.08, 0] },
      { geometry: new THREE.BoxGeometry(0.117, 0.018, 0.117), color: "#33383d", position: [-0.26, 1.152, 0] },
      { geometry: new THREE.ConeGeometry(0.09, 0.09, 4), color: "#262a2e", position: [-0.26, 1.206, 0], rotation: [0, 0.785398, 0] },
    ],
  animations: [],
});
